import { c as _c } from "react/compiler-runtime";
import { InterfaceChainUtils } from '@morpho-org/dapp-core';
import { Avatar } from '@morpho-org/ui-v6/client';
import { TruncatedTooltip } from '@repo/ui';
import { memo } from 'react';
import type { VaultV2PendingTimelock } from '@/components/VaultPage/VaultV2/types/pendingTimelocks';
import { InternalLink } from '@/components/common/InternalLink';
import { getVaultUrl } from '@/helpers/routing';
import { HoverableWrapper } from '../VaultV2PendingTimelockStyled';
type VaultV2AdapterPendingData = Extract<VaultV2PendingTimelock['decodedData'], {
  __typename: 'VaultV2AdapterPendingData';
}>;
type Adapter = NonNullable<VaultV2AdapterPendingData['adapter']>;
interface AdapterItemLinkProps {
  adapter: Adapter | null | undefined;
}
const AdapterItemLink = t0 => {
  const $ = _c(15);
  const {
    adapter
  } = t0;
  if (adapter?.__typename !== "MetaMorphoAdapter") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="gap-xs flex items-center">Market V1</div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const {
    metaMorpho
  } = adapter;
  const displayName = metaMorpho.name;
  let t1;
  if ($[1] !== metaMorpho.address || $[2] !== metaMorpho.chain.id || $[3] !== metaMorpho.name) {
    t1 = getVaultUrl({
      identifier: InterfaceChainUtils.getIdentifierById(metaMorpho.chain.id),
      vaultAddress: metaMorpho.address,
      vaultName: metaMorpho.name
    });
    $[1] = metaMorpho.address;
    $[2] = metaMorpho.chain.id;
    $[3] = metaMorpho.name;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== metaMorpho.asset.logoURI) {
    t2 = <Avatar src={metaMorpho.asset.logoURI} size="small" />;
    $[5] = metaMorpho.asset.logoURI;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== displayName) {
    t3 = displayName && <TruncatedTooltip text={displayName}>{ref => <span ref={ref} tabIndex={-1} className="min-w-0 truncate">{displayName}</span>}</TruncatedTooltip>;
    $[7] = displayName;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <HoverableWrapper><div className="gap-xs flex min-w-0 items-center">{t2}{t3}</div></HoverableWrapper>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t1 || $[13] !== t4) {
    t5 = <InternalLink href={t1} onClick={_temp}>{t4}</InternalLink>;
    $[12] = t1;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
export default memo(AdapterItemLink);
function _temp(e) {
  return e.stopPropagation();
}